import React, { memo, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import AVALIACAO_STATUS from '../enums/AVALIACAO_STATUS';
import { isAvaliacaoEncerradaPorAcessoNegado } from '../pages/Avaliacoes/_shared/avaliacaoAccessError';
import services from '../services';

const EntidadeAvaliacaoContext = React.createContext();

const initialState = {
  avaliacaoId: '',
  avaliacao: null,
  isLoadingAvaliacaoStatus: false,
  hasResolvedAvaliacaoStatus: false
};

const reducers = (state = initialState, action) => {
  if (action.type === 'AVALIACAO_ID_CHANGED') {
    return {
      ...state,
      avaliacaoId: action.payload
    };
  }

  if (action.type === 'AVALIACAO_STATUS_LOADING_CHANGED') {
    return {
      ...state,
      isLoadingAvaliacaoStatus: action.payload
    };
  }

  if (action.type === 'AVALIACAO_STATUS_RESOLVED_CHANGED') {
    return {
      ...state,
      hasResolvedAvaliacaoStatus: action.payload
    };
  }

  if (action.type === 'AVALIACAO_CHANGED') {
    return {
      ...state,
      avaliacao: action.payload
    };
  }

  return state;
};

const actions = {
  updateAvaliacaoId: pPayload => ({
    type: 'AVALIACAO_ID_CHANGED',
    payload: pPayload
  }),
  updateAvaliacaoStatusLoading: pPayload => ({
    type: 'AVALIACAO_STATUS_LOADING_CHANGED',
    payload: pPayload
  }),
  updateAvaliacaoStatusResolved: pPayload => ({
    type: 'AVALIACAO_STATUS_RESOLVED_CHANGED',
    payload: pPayload
  }),
  updateAvaliacao: pPayload => ({
    type: 'AVALIACAO_CHANGED',
    payload: pPayload
  })
};

export const useEntidadeAvaliacaoContext = () => React.useContext(EntidadeAvaliacaoContext);

export const EntidadeAvaliacaoProvider = memo(props => {
  const params = useParams();
  const [state, dispatch] = React.useReducer(reducers, initialState);

  const readAvaliacaoStatus = pAvaliacaoId => {
    const xAvaliacaoId = pAvaliacaoId || '';

    dispatch(actions.updateAvaliacaoId(xAvaliacaoId));
    dispatch(actions.updateAvaliacao(null));

    if (!xAvaliacaoId) {
      dispatch(actions.updateAvaliacaoStatusLoading(false));
      dispatch(actions.updateAvaliacaoStatusResolved(true));
      return () => {};
    }

    dispatch(actions.updateAvaliacaoStatusResolved(false));
    dispatch(actions.updateAvaliacaoStatusLoading(true));

    let xMounted = true;

    services.avaliacoes.status(
      { avaliacao_id: xAvaliacaoId },
      rRes => {
        if (!xMounted) return;

        dispatch(actions.updateAvaliacao(rRes?.data || null));
      },
      pErro => {
        if (!xMounted) return;

        if (isAvaliacaoEncerradaPorAcessoNegado(pErro)) {
          dispatch(
            actions.updateAvaliacao({
              avaliacao_id: xAvaliacaoId,
              status: AVALIACAO_STATUS.CANCELADA.id
            })
          );
          return;
        }

        dispatch(actions.updateAvaliacao(null));
      },
      () => {
        if (!xMounted) return;

        dispatch(actions.updateAvaliacaoStatusLoading(false));
        dispatch(actions.updateAvaliacaoStatusResolved(true));
      }
    );

    return () => {
      xMounted = false;
    };
  };

  useEffect(() => {
    return readAvaliacaoStatus(params['*']);
  }, [params['*']]);

  return (
    <EntidadeAvaliacaoContext.Provider
      value={{
        state,
        actions: {
          readAvaliacaoStatus
        }
      }}>
      {props.children}
    </EntidadeAvaliacaoContext.Provider>
  );
});

export default EntidadeAvaliacaoProvider;
